export const AwardsLinks = {
	data: [
		{
			title: 'Node.js',
			institution: 'IBM',
			issuedOn: 'February 06, 2019',
			link: 'https://www.credly.com/badges/2d9a9281-7714-4515-a929-10b0420efc7d/linked_in_profile'
		},
		{
			title: 'Quantum Computing Intro',
			institution: 'IBM',
			issuedOn: 'February 07, 2019',
			link: 'https://www.credly.com/badges/551d50c5-c483-453f-a488-a1b8b9ddbad4/linked_in_profile'
		},
		{
			title: 'HTML & CSS',
			institution: 'IBM',
			issuedOn: 'November 13, 2018',
			link: 'https://www.credly.com/badges/29222624-0564-4695-b659-46ed6cd4e284/linked_i'
		},
		{
			title: 'JavaScript',
			institution: 'IBM',
			issuedOn: 'November 20, 2018',
			link: 'https://www.credly.com/badges/0263760b-6d0b-4b05-a6cc-07fec18988c4/linked_in_profile'
		},
		{
			title: 'Artificial Intelligence',
			institution: 'IBM',
			issuedOn: 'October 24, 2018',
			link: 'https://www.credly.com/badges/cf1a9133-b4f9-4c42-83bd-4b9b1f81026c/linked_in_profile'
		},
		{
			title: 'Node-Red: basics to bots',
			institution: 'IBM',
			issuedOn: 'October 29, 2018',
			link: 'https://www.credly.com/badges/ac7704f5-b69d-47d9-8f16-a94b0e860d7b/linked_in_profile'
		},
		{
			title: 'Build Auction Application on Blockchain',
			institution: 'IBM',
			issuedOn: 'September 10, 2018',
			link: 'https://www.credly.com/badges/47ddab8f-1cab-47e7-8242-c48e2fde8ee8/linked_in_profile'
		},
		{
			title: 'Build Voting Application on Blockchain',
			institution: 'IBM',
			issuedOn: 'September 11, 2018',
			link: 'https://www.credly.com/badges/fbe4798d-7c0f-4ef3-84c9-e0412558603f/linked_in_profile'
		},
		{
			title: 'Build your own chatbot',
			institution: 'IBM',
			issuedOn: 'September 07, 2018',
			link: 'https://www.credly.com/badges/6212a810-5b4d-4972-b0d9-a9ba15e58d9d/linked_in_profile'
		},
		{
			title: 'Find Valuable Insights with IBM Watson',
			institution: 'IBM',
			issuedOn: 'September 08, 2018',
			link: 'https://www.credly.com/badges/33066994-d319-4860-aee8-9ebedf34ce04/linked_in_profile'
		},
		{
			title: 'Getting Started with IBM Cloud',
			institution: 'IBM',
			issuedOn: 'September 07, 2018',
			link: 'https://www.credly.com/badges/7ae79ef0-04c0-4660-8f23-7f824687d7cf/linked_in_profile'
		},
		{
			title: 'Identify Potential Repeat Customers for Your Business',
			institution: 'IBM',
			issuedOn: 'September 10, 2018',
			link: 'https://www.credly.com/badges/56dab272-446c-4a2f-93fe-ab36130228ba/linked_in_profile'
		},
		{
			title: 'Learn Color Design Course',
			institution: 'Codecademy',
			issuedOn: 'September 12, 2018',
			link: 'https://www.codecademy.com/profiles/kelvink96/certificates/0a6884fad1dbf4afe5df084d2ec1e7c3'
		},
		{
			title: 'Predict using IBM Watson Studio',
			institution: 'IBM',
			issuedOn: 'September 10, 2018',
			link: 'https://www.credly.com/badges/13634173-ea54-4fbc-9e3b-5dde23d3c586/linked_in_profile'
		},
		{
			title: 'Web Development',
			institution: 'IBM',
			issuedOn: 'September 09, 2018',
			link: 'https://www.credly.com/badges/f0f04288-384a-4895-8311-72510e0eee33/linked_in_profile'
		},
		{
			title: 'Application Security Analyst - Explorer Award for Students 2016',
			institution: 'IBM',
			issuedOn: 'September 30, 2016',
			link: 'https://www.credly.com/badges/95bbcbbc-28b7-47a2-8a46-d029ab2e7f1d/linked_in_profile'
		},
		{
			title: 'Web Security',
			institution: 'IBM',
			issuedOn: 'September 22, 2018',
			link: 'https://www.credly.com/badges/2be31a8d-31b8-4194-9356-ada5c95e5837/linked_in_profile'
		}
	]
}
